import React from "react";
import { Box, TextField } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { uploadFile } from "../../../../apis/settingsApis/policy-apis/policyApis";
import UploadFileDialog from "../../../../components/UploadFileDialog/UploadFileDialog";

function UploadPolicyDialog({
  open,
  onClose,
  policyData,
  close,
  refetch,
  version,
  isCreate,
}) {
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();

  const handleFileUpload = async (file) => {
    const accessToken = await getAccessTokenSilently();
    const idToken = (await getIdTokenClaims()).__raw;
    await uploadFile(
      file,
      policyData?.policyId,
      version,
      accessToken,
      idToken,
      isCreate
    );
    refetch();
    close();
  };

  const topContent = (
    <Box sx={{ mb: 2 }}>
      <TextField
        fullWidth
        label="Document Name"
        variant="outlined"
        value={policyData?.policyDisplayName}
        disabled
        required
        margin="dense"
        sx={{ mb: 1 }}
      />
      <TextField
        fullWidth
        label="Document Type"
        variant="outlined"
        value="Policy"
        disabled
        required
        margin="dense"
      />
      <Box sx={{ mt: 1, mb: 1 }} />
    </Box>
  );

  return (
    <UploadFileDialog
      open={open}
      onClose={onClose}
      onFileUpload={handleFileUpload}
      allowedFileTypes={[".docx", ".pdf"]}
      dialogTitle="Upload File"
      uploadButtonText="Save as Draft"
      topContent={topContent}
    />
  );
}

export default UploadPolicyDialog;
